// 상세이미지 대체텍스트(coupangDoc imagePage.details.altText) 고르기 — 의존성 없는 순수 함수(시험: __tests__/detailAltText.test.mjs).
// 예전엔 SEO 설명이 비면 `${productName} 상세 설명` 이었는데 productName 은 1688 중국어 원제목이라 견적 최종 검증 «중국어» 에 걸렸다
// (ourworks 7CF48F 261020016001). 순서 = SEO 설명 → SEO 상품명 → 번역 상품명 → 기본 글(store/index.js 상세 altText 와 같은 순서) · 원제목은 안 씀.
// server.js /api/rocketReg/updateFeature 도 같은 순서를 손으로 따른다(서버는 이 파일을 못 불러온다).

// 한자·전각 괄호·«1688» 거름 — SEO·옵션명에 남은 한자가 새도 견적 최종 검증(schemaValidator.containsChinese)에 걸리지 않게
// (newtopia PR261020-54B539). 대체텍스트 거름은 이 한 곳 — detailImageService 초기 altText 도 이것을 부른다.
export function stripAltHan(text) {
  return String(text || '')
    .replace(/[\u4e00-\u9fff\u3400-\u4dbf\uf900-\ufaff]+/g, ' ') // 통합 한자 · 확장 A · 호환 한자(글자로 적으면 정규화돼 범위가 한글까지 번진다)
    .replace(/[（）【】「」『』《》]/g, ' ')
    .replace(/(^|\D)1688(?!\d)(의)?/g, '$1 ')
    .replace(/\s+/g, ' ')
    .trim()
}

export const DETAIL_ALT_DEFAULT = '상품 상세 설명'

export function detailAltText(product, optionKorName) {
  const seo = (product && product.seo) || {}
  // 후보마다 거른 뒤 처음 남는 것 — 한자뿐인 후보는 건너뛴다(걸러 비면 다음 후보 → 기본 글)
  const alt = [seo.metaDescription, seo.productName, product && product.productNameTrans].map(stripAltHan).find(Boolean) || DETAIL_ALT_DEFAULT
  const option = stripAltHan(optionKorName)
  return option ? `${alt} - ${option}` : alt
}

// 본체 자리 다시 고름 문 — 비었거나 한자(CJK 통합 한자)가 들었으면 true. 이미 중국어로 저장된 상품도 상세이미지를 다시 돌리면 낫는다.
const HAN = /[一-鿿]/
export function needsDetailAltText(current) {
  return !current || HAN.test(current)
}
